import React, { FC } from 'react';
import { FlexCol, Loader } from '@minecraft.atoms';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from '@blocs.i18n';
import { WindowWidthContext } from '@minecraft.utils';
import { AddPaymentProps } from './types';
import { Purchase } from '../types';
import { AddPaymentMethodV2 } from './AddPaymentMethodV2';
import { priceFormatter } from '../helpers/priceFormatter';
import { BillingCodes } from '../enums/plans';
import { MobileRegistrationUpsell } from './MobileRegistrationUpsell';

export const PaymentAndPlanDetails: FC<AddPaymentProps> = React.memo(
  ({
    addPaymentError,
    addPaymentLoading,
    onAddPaymentOption,
    threeDActionContext,
    onThreeDActionError,
    currencyCode,
    countryCode,
    paywallLocation,
    allowCancel,
    onCompletePurchase,
    selectedPlan,
    currentPurchase,
    completedPurchase,
    completePurchaseLoading,
    completePurchaseError,
    selectedPaymentOption,
    wallet,
    onSelectPaymentOption,
    onNext,
    onCancel,
    isAnnual,
    setIsAnnual,
    onPaymentCompleteRedirect,
    disableTrial,
    onApplyCoupon,
    couponLoading,
    applyCouponError,
    onRemoveCoupon,
    currentProfile,
  }) => {
    const { t } = useTranslation();
    const isMobile = WindowWidthContext.useIsMobile();
    const handleSetIsAnnual = () => setIsAnnual(!isAnnual);
    const price = priceFormatter({
      price: Number(selectedPlan?.price),
      currencyCode: selectedPlan?.currencyCode,
      countryCode,
      t,
    });
    const isFreePlanSelected = selectedPlan?.billingCode === BillingCodes.registration;

    return (
      <Loader
        loading={!selectedPlan}
        LoaderComponent={
          <FlexCol alignItems="stretch" w="full" data-testid="mobile-registration-loader" gap="2">
            <Skeleton width="100%" height="42px" />
            <Skeleton width="100%" height="500px" />
          </FlexCol>
        }
      >
        <FlexCol w="full" justifyContent="start" alignItems="start">
          {!isFreePlanSelected && isMobile && (
            <MobileRegistrationUpsell
              isAnnual={isAnnual}
              selectedPlan={selectedPlan}
              handleSetIsAnnual={handleSetIsAnnual}
              price={price}
              disableTrial={disableTrial}
            />
          )}
          <AddPaymentMethodV2
            addPaymentError={addPaymentError}
            addPaymentLoading={addPaymentLoading}
            allowCancel={allowCancel}
            completedPurchase={completedPurchase}
            completePurchaseError={completePurchaseError}
            completePurchaseLoading={completePurchaseLoading}
            countryCode={countryCode}
            currencyCode={currencyCode}
            currentPurchase={currentPurchase as Purchase}
            onNext={onNext}
            onCancel={onCancel}
            onCompletePurchase={onCompletePurchase}
            onAddPaymentOption={onAddPaymentOption}
            onSelectPaymentOption={onSelectPaymentOption}
            onThreeDActionError={onThreeDActionError}
            paywallLocation={paywallLocation}
            selectedPaymentOption={selectedPaymentOption}
            selectedPlan={selectedPlan}
            threeDActionContext={threeDActionContext}
            wallet={wallet}
            onPaymentCompleteRedirect={onPaymentCompleteRedirect}
            onApplyCoupon={onApplyCoupon}
            couponLoading={couponLoading}
            applyCouponError={applyCouponError}
            onRemoveCoupon={onRemoveCoupon}
            currentProfile={currentProfile}
          />
        </FlexCol>
      </Loader>
    );
  }
);
